export const FRACTION_INPUT_MAX_LENGTH = 79;
export const NUMBER_TABLE_ITEMS = 10;
export const TASTE_TEST_DETAIL_COUNTDOWN_ID = "SUNDAESWAP_TASTE_TEST_COUNTDOWN";
export const TASTE_TEST_PENDING_TEASER_COUNTDOWN_ID = "TASTE_TEST_PENDING_TEASER_COUNTDOWN_ID";
export const EARNINGS_COUNTDOWN_ID = "SUNDAESWAP_EARNINGS_COUNTDOWN";
export const APP_NAME = "SundaeSwap DEX";

export const getPageTitle = (title: string) => `${title} | ${APP_NAME}`;
export const userPrefersDarkMode = () =>
  localStorage.theme === "dark" ||
  (!("theme" in localStorage) && window.matchMedia("(prefers-color-scheme: dark)").matches);
